import EventList from './eventComponents/EventList';
import './css/Events.css';
import { useEffect, useState } from 'react';
import { fetchEventsWithMetadata } from '../api/events';
import { useMemo } from 'react';
import { EventStructuredData } from './Seo';

const Events = () => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [cachedAt, setCachedAt] = useState('');

    useEffect(() => {
        fetchEventsWithMetadata()
            .then((result) => {
                setEvents(result.events);
                setCachedAt(result.stale ? result.updatedAt : '');
            })
            .catch((requestError) => {
                console.error(requestError);
                setError('Events are temporarily unavailable. Please try again later.');
            })
            .finally(() => setLoading(false));
    }, []);

    const eventData = useMemo(
        () =>
            events.map((e) => ({
            ...e,
            startDate: new Date(e.startDate),
            endDate: new Date(e.endDate),
            })),
        [events]
    );
    return (
        <main className="events-page">
            <EventStructuredData events={eventData} />
            <section className="event-page-title">
                <h1>Upcoming Events</h1>
                <p>Catch Ken & Bryn teaching, competing, and performing around the world.</p>
            </section>
            {cachedAt && (
                <p className="events-data-notice" role="status">
                    Google Calendar is temporarily unavailable. Showing the last saved schedule from{' '}
                    {new Date(cachedAt).toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' })}.
                </p>
            )}
            {loading ? (
                <div className="events-loading" role="status" aria-live="polite">
                    <span className="events-loading-spinner" aria-hidden="true"></span>
                    <span>Loading events...</span>
                </div>
            ) : error ? (
                <p className="events-message" role="alert">{error}</p>
            ) : eventData.length === 0 ? (
                <p className="events-message">No upcoming events are currently listed.</p>
            ) : (
                <EventList events={eventData} />
            )}
        </main>
    );
};

export default Events;
